<template>
    <div :id="'drag'+id" :ref="'drag'+id" class="skill draggable" :class="[skillCollapsed]" draggable="true" @click.prevent="onClick" @touchstart.prevent="touchStart" @touchmove.prevent="touchMove" @touchend.prevent="touchEnd">
        <div class="inset">
            <div class="handle">
                <font-awesome-icon 
                    :icon="['fas', 'chevron-left']"
                    class="font-awesome-icon" 
                    size="xs"
                />
                <font-awesome-icon 
                    :icon="['fas', 'chevron-up']"
                    class="font-awesome-icon" 
                    size="xs"
                    style="font-size: 0.5em"
                />
                <font-awesome-icon 
                    :icon="['fas', 'chevron-down']"
                    class="font-awesome-icon" 
                    size="xs"
                    style="font-size: 0.5em"
                />
            </div>
            <h5 v-html="title"></h5>
            <div class="question-text"> 
                <p :ref="'content'+id" v-html="text"></p>
            </div> 
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: Number,
        title: String,
        text: String,
    },
    data() {
        return {
            refName: null,
            contentRefName: null,
            isCollapsed: true,
            timeTouchstart: 0,
            coordsTouchstart: null,
            touchDistanceThreshold: 10,
            touchStarted: false,
            touchCancelled: false,
        }
    },
    computed: {
        skillCollapsed() {
            if(this.isCollapsed) {
                return 'collapsed';
            }

            return 'expanded';
        },
    },
    methods: {
        'touchStart': function(event) {
            this.touchStarted = true;
            this.touchCancelled = false;

            if(event.changedTouches.length > 0) {
                this.coordsTouchstart = event.changedTouches[0];
            } else if (event.touches.length > 0) {
                this.coordsTouchstart = event.touches[0];
            } else {
                this.coordsTouchstart = null;
                this.touchStarted = false;
            }
        },
        'touchMove': function(event) {
            if(!this.touchStarted) {
                this.touchCancelled = true;
                return;
            }

            if(this.coordsTouchstart && event.changedTouches.length > 0) {
                let a = this.coordsTouchstart.screenX - event.changedTouches[0].screenX;
                let b = this.coordsTouchstart.screenY - event.changedTouches[0].screenY;

                let distance = Math.sqrt( a*a + b*b );

                if(distance > this.touchDistanceThreshold) {
                    this.touchCancelled = true;
                }
            }
        },
        'touchEnd': function(event) {
            if(this.touchStarted && !this.touchCancelled) {
                this.onClick(event);
            }
        },
        'onClick': function(event) {
            if(this.touchStarted && !this.touchCancelled && event.type === 'click') {
                return;
            }

            window.$vm.$emit('collapseQuestionComponents', this);
            this.isCollapsed = !this.isCollapsed;

            event.stopPropagation();
        }
    },
    mounted() {
        window.$vm.$on('collapseQuestionComponents', (component) => {
            if(component != this) {
                this.isCollapsed = true;
            }
        })
    }
}
</script>